<nz-skeleton *ngIf="!reportId"></nz-skeleton>
<app-report-main [reportId]="reportId" *ngIf="reportId">

</app-report-main>
